// src/pages/Workflows.js
import React, { useState } from 'react';
import './Workflows.css';

function ZoomableImage({ src, alt }) {
  const [scale, setScale] = useState(1);
  const zoomStep = 0.2;
  const minScale = 0.5;
  const maxScale = 5;

  const zoomIn = () => {
    setScale(prev => Math.min(prev + zoomStep, maxScale));
  };

  const zoomOut = () => {
    setScale(prev => Math.max(prev - zoomStep, minScale));
  };

  // Allow zooming with the touchpad/mouse wheel
  const handleWheel = (e) => {
    e.preventDefault();
    // Zoom in if scrolling up; zoom out if scrolling down.
    if (e.deltaY < 0) {
      zoomIn();
    } else if (e.deltaY > 0) {
      zoomOut();
    }
  };

  return (
    <div className="zoomable-image-container">
      <div className="zoom-controls">
        <button onClick={zoomOut} className="zoom-button">−</button>
        <button onClick={zoomIn} className="zoom-button">+</button>
      </div>
      <div 
        className="image-wrapper" 
        style={{ transform: `scale(${scale})` }}
        onWheel={handleWheel}
      >
        <img src={src} alt={alt} />
      </div>
    </div>
  );
}

function Workflows() {
  return (
    <div className="workflows-page">
      <h1>Internal Workflows</h1>
      <p>
        Welcome to the NESIM Intranet Workflows page. Here you will find detailed, step-by-step process diagrams for our key business functions.
      </p>

      <section className="workflow-svg-section">
        <h2>Technical Sales Workflow</h2>
        <p>
          This flowchart outlines the processes for our technical sales operations, including customer engagement, quotation, follow-up, and closure.
        </p>
        <div className="svg-container">
          <ZoomableImage src="/svgs/technical-sales-workflow.svg" alt="Technical Sales Workflow" />
        </div>
      </section>

      <section className="workflow-svg-section">
        <h2>NESIM Store Management Workflow</h2>
        <p>
          This diagram illustrates our store operations—from receiving and inventory management to order dispatch and storage optimization.
        </p>
        <div className="svg-container">
          <ZoomableImage src="/svgs/nesim-store-management-workflow.svg" alt="NESIM Store Management Workflow" />
        </div>
      </section>

      <section className="workflow-svg-section">
        <h2>NESIM Sales Workflow</h2>
        <p>
          This flowchart demonstrates our sales process, covering lead generation, customer onboarding, sales negotiation, and post-sales follow-up.
        </p>
        <div className="svg-container">
          <ZoomableImage src="/svgs/nesim-sales-workflow.svg" alt="NESIM Sales Workflow" />
        </div>
      </section>

      <section className="workflow-svg-section">
        <h2>NESIM Import Workflow</h2>
        <p>
          This diagram details our import process—from supplier selection and shipping logistics to quality assurance and delivery—to ensure timely access to brewing ingredients.
        </p>
        <div className="svg-container">
          <ZoomableImage src="/svgs/nesim-import-workflow.svg" alt="NESIM Import Workflow" />
        </div>
      </section>
    </div>
  );
}

export default Workflows;
